const SET_USER = 'setUser';
const SET_CREDENTIALS = 'setCredentials';

export { SET_USER, SET_CREDENTIALS };
